<template xmlns:v="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="row">
            <div class="col-11 mx-auto">
                <RenamableProperty
                    inputClasses="rename-input"
                    v-bind:name="name"
                    v-bind:locked="lockedByParent"
                    v-on:rename-property="$emit('rename-page', $event)"
                >
                </RenamableProperty>
            </div>
        </div>

        <TemplateItem
            v-bind:metadata="metadata"
            v-bind:isSelected="isSelected"
            v-bind:classes="classes"
            v-bind:parentId="parentId"
            v-bind:styles="pageStyle"
            v-bind:controlsStyle="'right: -33px; top: -26px;'"
            v-bind:isParent="isParent"
            v-bind:locked="locked"
            v-on:delete-item="$emit('delete-page', $event)"
            v-on:select-item="$emit('select-page')"
            v-on:move-item="$emit('move-page', $event)"
            v-on:rename-item="$emit('rename-page', $event)"
            v-on:lock-item="$emit('lock-page', $event)"
            v-on:unselect-all="selectedBlock = null"
        >
            <template v:slot="settings" v-if="showSettings">
                <TemplatePageSettings
                    v-bind:width="metadata.style.width"
                    v-bind:color="metadata.style.color"
                    v-bind:margin="metadata.style.margin"
                    v-bind:media-id="metadata.style.mediaId"
                    v-on:change-width="$emit('change-width', $event)"
                    v-on:change-color="$emit('change-color', $event)"
                    v-on:change-image="$emit('change-image', $event)"
                    v-on:change-crop="$emit('change-crop', $event)"
                    v-on:change-margin="$emit('change-margin', $event)"
                />
            </template>
            <templateBlock
                v-for="block in sortedBlocks"
                v-bind:key="block._key"
                v-bind:id="block.Id"
                v-bind:currentTemplateId="currentTemplateId"
                v-bind:templateId="block.TemplateId"
                v-bind:parentId="block.ParentId"
                v-bind:isSelected="selectedBlock === block"
                v-bind:locked="block.IsLocked"
                v-bind:lockStateChanged="block.LockStateChanged"
                v-on:select-block="selectedBlock = block"
                v-bind:pageId="block.PageId"
                v-bind:metadata="block.Metadata"
                v-bind:rows="block.Rows"
                v-bind:settings="{ margin: metadata.style.margin }"
                v-bind:parentColor="metadata.style.color"
                v-on:delete-block="deleteBlock($event)"
                v-on:move-block="moveBlock($event.old, $event.new)"
                v-on:lock-block="toggleBlockLock(block, $event)"
                v-on:change-width="block.Metadata.style.width = $event"
                v-on:change-color="block.Metadata.style.color = $event"
                v-on:change-border-color="block.Metadata.style.borderColor = $event"
                v-on:change-radius="block.Metadata.style.radius = $event"
                v-on:item-added="$emit('item-added')"
                v-on:set-border="block.Metadata.style.border = $event"
            >
            </templateBlock>

            <div v-if="!lockedByParent" class="row">
                <div class="col-auto mx-auto">
                    <i class="mdb-icon-btn new fa fa-plus-circle fa-2x" v-on:click.stop="addBlock()" data-toggle="tooltip" v-bind:title="tooltips.insertBlock"></i>
                </div>
            </div>

            <slot name="pagenumber">
                
            </slot>
        </TemplateItem>

    </div>
</template>

<script>
    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../../Util/Mixins/tooltips";

    import {applyDefaults, blockDefaults} from "../defaults";

    import selectableItemMixin from '../Mixins/selectable-item';
    import {insertBlockTooltip} from "../tooltips";
    import imageUrlMixin from '../Mixins/image-url'
    import guidMixin from '../../../Util/Mixins/guid';

    import TemplateItem from './TemplateItem.vue';
    import RenamableProperty from '../../../Components/Util/RenamableProperty.vue';
    import TemplatePageSettings from './Settings/TemplatePageSettings.vue';
    import Block from './TemplateBlock.vue';

    export default {
        name: 'template-page',
        mixins: [imageUrlMixin, autoInitializeTooltipsMixin, guidMixin, selectableItemMixin],
        components: {
            TemplateItem,
            RenamableProperty,
            TemplatePageSettings,
            'TemplateBlock': Block
        },
        methods: {
            addBlock() {
                const vm = this;

                let block = {
                    _key: vm.guid(),
                    TemplateId: vm.currentTemplateId,
                    PageId: vm.id,
                    IsLocked: false,
                    LockStateChanged: false,
                    Metadata: {
                        index: vm.lastBlock + 1
                    },
                    Rows: []
                };
                
                applyDefaults(blockDefaults, block.Metadata);

                vm.blocks.push(block);
                this.$emit('item-added');
            },
            toggleBlockLock(block, locked) {
                block.IsLocked = locked;
                block.LockStateChanged = !block.LockStateChanged;
            },
            deleteBlock(index) {
                const blocks = this.blocks;
                blocks.splice(index-1,1);

                for(let i = 0 ; i < blocks.length ; i++) {
                    blocks[i].Metadata.index = i+1;
                }
            },
            moveBlock(oldIndex, newIndex) {
                let blocks = this.blocks;
                var target = blocks.splice(oldIndex-1, 1)[0];
                blocks.splice(newIndex-1, 0, target);

                //re-index metadata
                for(let i = 0 ; i < blocks.length ; i++) {
                    blocks[i].Metadata.index = i+1;
                }
            }
        },
        watch: {
            selectedBlock(value){
                //Upon selecting a block, also select the page
                if(value){
                    this.emitSelection('select-page', this.metadata);
                }
            }
        },
        computed: {
            showSettings() {
                return this.isSelected && !this.lockedByParent;
            },
            lockedByParent() {
                return  (this.locked && this.isParent);
            },
            lastBlock() {
                return this.blocks.length;
            },
            pageStyle(){
                const vm = this;
                
                const rules = [];

                //Background image is optional
                if(vm.metadata.style.mediaId){
                    rules.push(`background-image: url(${vm.getImageUrl(vm.metadata.style.mediaId, vm.metadata.style)})`);
                    rules.push('background-size: cover');
                }

                rules.push('width: ' + vm.metadata.style.width + 'px');
                rules.push(`background-color: ${vm.metadata.style.color}`);
                
                return rules.join(';');
            },
            sortedBlocks() {
                return this.blocks.sort((left, right) => {
                    if(left.Metadata.index < right.Metadata.index)
                        return -1;
                    if(left.Metadata.index > right.Metadata.index)
                        return 1;
                    return 0;
                });
            },
            isParent() {
                return this.currentTemplateId.toLowerCase() !== this.templateId.toLowerCase();
            },
            classes(){
                const classList = [
                    'mx-auto',
                    'template-page'
                ];

                if(this.isSelected){
                    classList.push('selected-page');
                }

                return classList.join(' ');
            }
        },
        data() { 
            return {
                tooltips: {
                    insertBlock: insertBlockTooltip
                },
                
                selectedBlock: null,
                model: null
            };
        },
        props: {
            id: {
                type: String,
                required: false
            },
            parentId: {
                type: String,
                default: null
            },
            locked: {
                type: Boolean,
                default: false
            },
            lockStateChanged: {
                type: Boolean,
                required: true
            },
            isSelected: {
                type: Boolean,
                required: true
            },
            currentTemplateId: {
                type: String,
                required: true
            },
            templateId: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            metadata: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        index: 0,
                        style: {
                            mediaId: '',
                            crop: {
                                x: 0,
                                y: 0,
                                w: 0,
                                h: 0
                            },
                            width: 100,
                            margin: 30,
                            color: '',
                        }
                    };
                }
            },
            blocks: {
                type: Array,
                required: true
            }
        }
    };
</script>

<style scoped src="../Style/template-page.scss" lang="scss">
</style>
